<template>
  <ul class="list_titleStyle list-unstyled" :class="listStyled">
    <li
      :data-tit="$t('bikeOverview.bikeInformation.' + info.name)"
      v-for="(info, index) in infolists"
      :key="index"
    >
    <p :class="info.class" v-if="info.lang">{{info.otherData}} {{ $t('bikeOverview.bikeInformation.' + info.content) }}</p>
    <p :class="info.class" v-else>{{ info.content }} <span>{{info.otherData}}</span></p>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'BikeInfoItem',
  data () {
    return {};
  },
  props: [
    'listStyled',
    'infolists'
  ]
};
</script>
